import type { RecordItem } from '#/common/components/RecordPreview';
import type { WorkOrderDetails } from '#/graphql/types';

export type FsmWorkOrderRecord = WorkOrderDetails & {
  locationName?: string | null;
  assignedToName?: string | null;
  assetName?: string | null;
  parentNumber?: string | null;
  lineItemsCountValue?: number | null;
  priorityLabel?: string | null;
  serviceContractNumber?: string | null;
};

const GRID_QUARTER = { xs: 6, sm: 6, md: 3, lg: 3 };
const GRID_THIRD = { xs: 6, sm: 6, md: 4, lg: 4 };
const GRID_FULL = { xs: 12, sm: 12, md: 12, lg: 12 };

export const fsmWoFields = (navigate: (url: string) => void): RecordItem<FsmWorkOrderRecord>[] => [
  {
    items: [
      {
        dataField: 'thirdPartyNumber',
        label: 'Work Order Number',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'locationName',
        label: 'Location',
        dataType: 'link',
        valueExpr: 'locationId',
        url: '/assets/locations/:id/details',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'lineItemsCountValue',
        label: 'Work Order Line Items',
        dataType: 'string',
        onClick: () => navigate('../line-items'),
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'assignedToName',
        label: 'Assigned To',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
    ],
  },
  {
    items: [
      {
        dataField: 'title',
        label: 'Title',
        dataType: 'string',
        gridOptions: GRID_FULL,
      },
      {
        dataField: 'state',
        label: 'Status',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'category',
        label: 'Category',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'priorityLabel',
        label: 'Priority',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'startDate',
        label: 'Start Date',
        dataType: 'datetime',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'endDate',
        label: 'End Date',
        dataType: 'datetime',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'dueDate',
        label: 'Planned Date',
        dataType: 'date',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'closedNotes',
        label: 'Closing Notes',
        dataType: 'external-link',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'serviceContractNumber',
        label: 'Service Contract Number',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'description',
        label: 'Description',
        dataType: 'string',
        gridOptions: GRID_FULL,
      },
    ],
  },
];

export const fsmWoliFields = (
  navigate: (url: string) => void,
): RecordItem<FsmWorkOrderRecord>[] => [
  {
    items: [
      {
        dataField: 'title',
        label: 'Line Item Number',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'assetName',
        label: 'Asset',
        dataType: 'link',
        valueExpr: 'assetId',
        url: '/assets/:id/details',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'parentNumber',
        label: 'Work Order',
        dataType: 'link',
        valueExpr: 'parentId',
        url: '/work-orders/:id/details',
        gridOptions: GRID_QUARTER,
      },
      {
        dataField: 'assignedToName',
        label: 'Assigned To',
        dataType: 'string',
        gridOptions: GRID_QUARTER,
      },
    ],
  },
  {
    items: [
      {
        dataField: 'title',
        label: 'Title',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'state',
        label: 'Status',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'priorityLabel',
        label: 'Priority',
        dataType: 'string',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'startDate',
        label: 'Start Date',
        dataType: 'datetime',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'endDate',
        label: 'End Date',
        dataType: 'datetime',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'dueDate',
        label: 'Planned Date',
        dataType: 'date',
        gridOptions: GRID_THIRD,
      },
      {
        dataField: 'closedNotes',
        label: 'Closing Notes',
        dataType: 'external-link',
        gridOptions: GRID_FULL,
      },
      {
        dataField: 'description',
        label: 'Subject',
        dataType: 'string',
        gridOptions: GRID_FULL,
      },
    ],
  },
];
